export const formatAnswers = questionnaire => {
  const formattedQuestionnaire = []

  questionnaire.forEach(item => {
    if (!item?.answer) return
    if (typeof item.answer === 'string') {
      item.answer = [item.answer]
    }

    item.answer = item.answer.filter(item => item !== '')

    if (item.intent) {
      item.intent = true
    }
    formattedQuestionnaire.push(item)
  })
  return formattedQuestionnaire
}
